import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  bold: {
    fontFamily: 'Source Sans Pro Semibold',
  },

  container: {
    background: '#f4faff',
    borderBottom: '0.4px solid #d1d1d1',
    color: theme.palette.text.primary,
    fontFamily: 'Source Sans Pro',
    fonSize: '14px',
    height: '34px',
    lineHeight: '34px',
    padding: `0 ${theme.spacing(4.8)}`,
  },

  details: {
    fontFamily: 'Source Sans Pro',
    margin: `0 ${theme.spacing(2.4)} 0 ${theme.spacing(1.2)}`,
  },

  viewFullDetailsLink: {
    color: '#005AA3',
    cursor: 'pointer',
    fontSize: '14px',
  },
})
